<template>
    
</template>

<script>
    import {mapState} from 'vuex';
    export default {
        name: "SchoolFooterSection",
        data(){
            return {
                sectionType: "schoolFooter"
            }
        },
        computed: {
            ...mapState('footer', [
                'schoolFooterData'
            ]),   
            myData () {
                return this.schoolFooterData[this.footerStatus];
            },
        },
        methods: {
            acquireSectionData () {                
                if ( !this.schoolFooterData[this.footerStatus] || (this.schoolFooterData[this.footerStatus] && this.schoolFooterData[this.footerStatus].sectionId !== this.sectionId)) {
                    this.changeMyData(this.getDefaultDataStructure);
                } else if (!Object.keys(this.getDefaultDataStructure).every(key => typeof this.myData[key] !== "undefined") ) {

                    let updatedValues = {};

                    Object.keys(this.getDefaultDataStructure).forEach( key => {
                        let defaultValue = this.getDefaultDataStructure[key];
                        if (typeof this.myData[key] === "undefined") {
                            updatedValues[key] = defaultValue;
                        }
                    })

                    this.changeMyData(updatedValues);
                }
            },
        }
    }
</script>

